export default __webpack_public_path__ + "static/logo-hms-a5df70d6d6cab72bef81916f48a33169.png";